import {
  InfoCard,
  ActionCard,
  SelectCard,
  DefaultButton,
  Modal,
  SearchBarComponent,
  KanbanCard,
  ResumeInputCard,
  Select,
  ResumeSelectCard,
  InvestCard,
  ColorPicker,
  Slider,
  TextArea,
  Toggle,
  RadioButton,
  Checkbox,
  Banner,
  ShowDetails,
  CustomSelect,
  NewSelect,
  ButtonNext,
  ButtonCopy,
  MultiSelect,
} from 'components/index'
import ErrorMsg from 'components/ErrorMsg'
import { useContext, useState, useRef, useEffect } from 'react'
import { UserContext } from 'context/userContext'
import MigrarContrato from 'pages/Clientes/DetalhesCliente/Produtos/AdicionaisContrato/MigrarContrato'
import { Icon } from 'assets/index'
import { Form } from '@unform/web'
import { Theme } from 'styles/Themes'
import Div from './style'

export default function Demo() {
  const [checkCard, setCheckCard] = useState(true)
  const { showModal, setShowModal, checkbox, setCheckbox } =
    useContext(UserContext)
  const [garantiaSelecionada, setGarantiaSelecionada] = useState<string[]>([])
  const formRef = useRef<HTMLFormElement | any>(null)

  const handleGarantiaChange = (values: string[]) => {
    console.log('Selecionado:', values)
    setGarantiaSelecionada(values)
  }

  const garantias = [
    { value: 'garantia1', label: 'Garantia 1', color: '#00B8D9' },
    { value: 'garantia2', label: 'Garantia 2', color: '#0052CC' },
    { value: 'garantia3', label: 'Garantia 3', color: '#FF5630' },
    { value: 'garfanftia3', label: 'Garantia 3', color: '#FF5630' },
    {
      value: 'garanfa3',
      label: 'Garantiaddddddddddddddddd 3',
      color: '#FF5630',
    },
  ]

  return (
    <Div>
      <div style={{ width: '312px' }}>
        <Form ref={formRef} onSubmit={() => console.log(formRef)}>
          <MultiSelect
            name="garantee"
            dataTestId="lal"
            large
            hasAsterisk
            onChange={handleGarantiaChange}
            placeholder="Garantia"
            options={garantias} // ✅ adicionando a prop obrigatória
          />
        </Form>
      </div>
      <button
        onClick={() => {
          console.log('selectedGarantia', garantiaSelecionada)
        }}
        type="button"
      >
        TESTE
      </button>
      {/* <InfoCard small icon={Icon('money.svg')} value="7">
        Texto bem grande para testar o tamanho do card
      </InfoCard>
      <InfoCard icon={Icon('money.svg')} value="7">
        Número de colaboradores
      </InfoCard>
      <InfoCard large icon={Icon('money.svg')} value="7">
        Número de colaboradores
      </InfoCard>
      <InfoCard small secondary icon={Icon('money.svg')} value="7">
        Número
      </InfoCard>
      <ActionCard
        icon={Icon('money.svg')}
        value="Novo colaborador"
        onClick={() => console.log('clicou no card')}
        tag="Assinado"
      />
      <ActionCard
        icon={Icon('money.svg')}
        value="Novo colaborador"
        onClick={() => console.log('clicou no card')}
      />
      <SelectCard
        icon={Icon('money.svg')}
        value="Dashboard"
        onClick={() => setCheckCard((current) => !current)}
        checked={checkCard}
      /> */}
      <DefaultButton
        $loading={false}
        onClick={() => console.log('clicou no botao')}
      >
        Entrar
      </DefaultButton>
      <DefaultButton
        $loading={false}
        disabled
        small
        onClick={() => console.log('clicou no botao')}
      >
        Entrar
      </DefaultButton>
      <DefaultButton
        icon={Icon('plus.svg')}
        $loading={false}
        onClick={() => setShowModal((curr) => !curr)}
        small
      >
        Abrir modal
      </DefaultButton>
    </Div>
  )
}
